import React from 'react';
import { FiltersSecondaryList } from 'src/domains/layouts/webview/components/filtersSecondary/FiltersSecondary.style';
import { FilterSecondary } from 'src/domains/layouts/webview/components/filtersSecondary/FilterSecondary';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { FilterSecondaryWithBadge } from 'src/domains/layouts/webview/components/filtersSecondary/FilterSecondaryWithBadge';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';
import { shouldShowOutrightsFilter, SportsFilterChipType } from './UnifiedSportsFilters.state';
import { MatchesFilterLabel } from './MatchesFilterLabel';
import { observer } from 'src/utils/mobx-react';

interface SportsFiltersCompetitionPrimaryRowPropsType {
    eventsListState: UnifiedSportEventsListState;
    onSportFilterChipChange: (chip: SportsFilterChipType) => void;
    outrightsCount: number;
}

export const SportsFiltersCompetitionPrimaryRow = observer(
    'SportsFiltersCompetitionPrimaryRow',
    ({
        eventsListState,
        onSportFilterChipChange,
        outrightsCount,
    }: SportsFiltersCompetitionPrimaryRowPropsType): JSX.Element => {
        const isOutrightsActive = eventsListState.filter_outrights === true;
        const isMatchesActive = isOutrightsActive === false;

        const handleOutrightsClick = (): void => {
            onSportFilterChipChange('outrights');
            eventsListState.setFilterOutrights(true);
        };

        const handleMatchesClick = (): void => {
            onSportFilterChipChange('featured');
            eventsListState.clearSecondaryFilters();

            if (eventsListState.filter_market === null && eventsListState.marketForEnv.length > 0) {
                eventsListState.changeFilter_market(eventsListState.marketForEnv[0]?.id ?? null);
            }
        };

        return (
            <FiltersSecondaryList>
                <FilterSecondary
                    isActive={isMatchesActive}
                    onClick={handleMatchesClick}
                    dataTestFilterKey='matches'
                >
                    <MatchesFilterLabel sportId={eventsListState.sport} />
                </FilterSecondary>

                {outrightsCount > 0 && shouldShowOutrightsFilter(eventsListState.sport) === true ? (
                    <FilterSecondaryWithBadge
                        badge={outrightsCount}
                        isActive={isOutrightsActive}
                        onClick={handleOutrightsClick}
                        dataTestFilterKey='outrights'
                    >
                        <I18n
                            langKey='events.coupons.outrights.label'
                            defaultText='Outrights'
                        />
                    </FilterSecondaryWithBadge>
                ) : null}
            </FiltersSecondaryList>
        );
    }
);
